import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    data: { titleKey: 'app.meta.title' },
    loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'category/:category',
    data: { titleKey: 'app.meta.title' },
    loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'filters',
    data: { titleKey: 'route.filters' },
    loadComponent: () => import('./features/filters/filters.component').then((m) => m.FiltersComponent),
  },

  {
    path: 'ad/new',
    data: { titleKey: 'route.ad.new', authRequired: true },
    loadComponent: () => import('./features/ad-create/ad-create.component').then((m) => m.AdCreateComponent),
  },
  {
    path: 'ad/:id/edit',
    data: { titleKey: 'route.ad.edit', authRequired: true },
    loadComponent: () => import('./features/ad-create/ad-create.component').then((m) => m.AdCreateComponent),
  },
  {
    path: 'ad/:id/payment',
    data: { titleKey: 'route.ad.payment', mobileShellTitle: true, mobileShellBack: true, authRequired: true },
    loadComponent: () => import('./features/ad-payment/ad-payment.component').then((m) => m.AdPaymentComponent),
  },
  {
    path: 'ad/list',
    data: { titleKey: 'route.ad.list', shellTitle: true, authRequired: true },
    loadComponent: () =>
      import('./features/my-ads/my-ads.component').then((m) => m.MyAdsComponent),
  },
  {
    path: 'ad/:id',
    loadComponent: () => import('./features/ad-view/ad-view.component').then((m) => m.AdViewComponent),
  },
  {
    path: 'favourites',
    data: { titleKey: 'route.favourites', shellTitle: true, authRequired: true },
    loadComponent: () =>
      import('./features/favourites/favourites.component').then((m) => m.FavouritesComponent),
  },
  {
    path: 'chat',
    data: { titleKey: 'route.chat', shellTitle: true, authRequired: true },
    loadComponent: () =>
      import('./features/chat/chat.component').then((m) => m.ChatComponent),
  },
  {
    path: 'agent',
    data: { titleKey: 'route.agent', authRequired: true },
    loadComponent: () =>
      import('./features/ai-agent/ai-agent.component').then((m) => m.AiAgentComponent),
  },
  {
    path: 'subscriptions',
    data: { titleKey: 'route.subscriptions', authRequired: true },
    loadComponent: () =>
      import('./features/subscriptions/subscriptions.component').then((m) => m.SubscriptionsComponent),
  },
  {
    path: 'payments-history',
    data: { titleKey: 'route.paymentsHistory', mobileShellTitle: true, mobileShellBack: true, authRequired: true },
    loadComponent: () =>
      import('./features/balance/balance.component').then((m) => m.BalanceComponent),
  },
  {
    path: 'login',
    data: { titleKey: 'route.login' },
    loadComponent: () => import('./features/auth/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'login/code',
    data: { titleKey: 'route.login.code' },
    loadComponent: () => import('./features/auth/login-code.component').then((m) => m.LoginCodeComponent),
  },
  {
    path: 'contacts',
    data: { titleKey: 'route.contacts', staticPage: 'contacts' },
    loadComponent: () =>
      import('./features/static-page/static-page.component').then((m) => m.StaticPageComponent),
  },
  {
    path: 'about-us',
    data: { titleKey: 'route.about', staticPage: 'about' },
    loadComponent: () =>
      import('./features/static-page/static-page.component').then((m) => m.StaticPageComponent),
  },
  {
    path: 'terms',
    data: { titleKey: 'route.terms', staticPage: 'terms' },
    loadComponent: () =>
      import('./features/static-page/static-page.component').then((m) => m.StaticPageComponent),
  },
  {
    path: 'privacy',
    data: { titleKey: 'route.privacy', staticPage: 'privacy' },
    loadComponent: () =>
      import('./features/static-page/static-page.component').then((m) => m.StaticPageComponent),
  },
  {
    path: 'offer',
    data: { titleKey: 'route.offer', staticPage: 'offer' },
    loadComponent: () =>
      import('./features/static-page/static-page.component').then((m) => m.StaticPageComponent),
  },
  {
    path: 'payment',
    data: { titleKey: 'route.payment', staticPage: 'payment' },
    loadComponent: () =>
      import('./features/static-page/static-page.component').then((m) => m.StaticPageComponent),
  },
  {
    path: 'my-profile',
    data: { titleKey: 'route.profile', mobileShellTitle: true, authRequired: true },
    loadComponent: () =>
      import('./features/profile/profile.component').then((m) => m.ProfileComponent),
  },
  {
    path: 'my-profile/form',
    data: { titleKey: 'route.profile.personalData', mobileShellTitle: true, mobileShellBack: true, authRequired: true },
    loadComponent: () =>
      import('./features/profile/profile-form.component').then((m) => m.ProfileFormComponent),
  },
  {
    path: 'my-profile/currency',
    data: { titleKey: 'route.profile.currency', mobileShellTitle: true, mobileShellBack: true, authRequired: true },
    loadComponent: () =>
      import('./features/profile/profile-currency.component').then((m) => m.ProfileCurrencyComponent),
  },
  {
    path: 'my-profile/balance',
    data: { titleKey: 'balance.title', mobileShellTitle: true, mobileShellBack: true, authRequired: true },
    loadComponent: () =>
      import('./features/balance/balance.component').then((m) => m.BalanceComponent),
  },
  {
    path: 'my-profile/mcp',
    data: { titleKey: 'route.profile.mcp', mobileShellTitle: true, mobileShellBack: true, authRequired: true },
    loadComponent: () =>
      import('./features/mcp/mcp-integration.component').then((m) => m.McpIntegrationComponent),
  },
  {
    path: 'mcp/oauth/authorize',
    data: { titleKey: 'route.profile.mcp', mobileShellTitle: true, mobileShellBack: true, authRequired: true },
    loadComponent: () =>
      import('./features/mcp/mcp-authorize.component').then((m) => m.McpAuthorizeComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
